<template>
	<div>
		<p class="text-smaller pb-4">{{$t('Az összes mező kitöltése kötelező!')}}</p>

		<form @submit.prevent="submit()">
			<div class="form-group form-group--with-icon">
                <label for="name" class="d-none">{{$t('Név')}}</label>
				<input
					ref="name"
					v-model.trim="$v.managedUserVM.name.$model"
					v-input-class
					type="text"
                    id="name"
					class="input"
					:placeholder="$t('Név')"
				/>
				<span class="input__icon">
					<img src="@/assets/icons/user.svg" :alt="$t('Név')" />
				</span>
				<div class="input__error" v-if="$v.managedUserVM.name.$error">
					<span>
						<img src="@/assets/icons/warning.svg" alt="Hiba" />
					</span>
					<span>{{$t('A mező kitöltése kötelező!')}}</span>
				</div>
			</div>

			<div class="form-group form-group--with-icon">
                <label for="email" class="d-none">{{$t('E-mail cím')}}</label>
				<input
					ref="email"
                    id="email"
					v-model.trim="$v.managedUserVM.email.$model"
					v-input-class
					type="email"
					class="input"
					:placeholder="$t('E-mail cím')"
				/>
				<span class="input__icon">
					<img src="@/assets/icons/email.svg" :alt="$t('E-mail cím')" />
				</span>
				<div class="input__error" v-if="$v.managedUserVM.email.$error">
					<span>
						<img src="@/assets/icons/warning.svg" alt="Hiba" />
					</span>
					<span v-if="!$v.managedUserVM.email.required">{{$t('A mező kitöltése kötelező!')}}</span>
					<span v-else-if="!$v.managedUserVM.email.email">{{$t('Hibás e-mail cím!')}}</span>
				</div>
			</div>

			<div class="form-group form-group--with-icon">
                <label for="tel" class="d-none">{{$t('Telefonszám')}}</label>
				<input
					ref="tel"
                    id="tel"
					v-model.trim="$v.managedUserVM.phone.$model"
					v-input-class
					type="tel"
					class="input"
					:placeholder="$t('Telefonszám')"
				/>
				<span class="input__icon">
					<img src="@/assets/icons/phone.svg" :alt="$t('Telefonszám')" />
				</span>
				<div class="input__error" v-show="$v.managedUserVM.phone.$error">
					<span>
						<img src="@/assets/icons/warning.svg" alt="Hiba" />
					</span>
					<span v-if="!$v.managedUserVM.phone.required">{{$t('A mező kitöltése kötelező!')}}</span>
					<span
						v-else-if="!$v.managedUserVM.phone.minLength"
					>{{$t('A telefonszámnak legalább 8 karakterből kell állnia!')}}</span>
				</div>
			</div>

			<div class="form-group form-group--password form-group--with-icon">
                <label for="password" class="d-none">{{$t('Jelszó')}}</label>
				<input
					ref="password"
                    id="password"
					v-model.trim="$v.managedUserVM.password.$model"
					v-input-class
					:type="showPassword? 'text' : 'password'"
					class="input"
					:placeholder="$t('Jelszó')"
				/>
				<span class="input__icon">
					<img src="@/assets/icons/lock.svg" :alt="$t('Jelszó')" />
				</span>
                <button
					type="button"
					@click.prevent.stop="showPassword = !showPassword"
					class="input__show-password"
				>
                    <inline-svg :src="require('@/assets/icons/eye-crossed.svg')"></inline-svg>
				</button>
                <div>
                    <password v-model="managedUserVM.password" :secureLength="8" :strength-meter-only="true"/>
                </div>
				<div class="input__error" v-show="$v.managedUserVM.password.$error">
					<span>
						<img src="@/assets/icons/warning.svg" alt="Hiba" />
					</span>
					<span v-if="!$v.managedUserVM.password.required">{{$t('A mező kitöltése kötelező!')}}</span>
					<span v-else-if="!$v.managedUserVM.password.minLength || !$v.managedUserVM.password.maxLength"
					>{{$t('A jelszó minimum 8 és maximum 20 karakter hosszú lehet!')}}</span>
                    <span v-else-if="!$v.managedUserVM.password.goodPassword"
					>{{$t('A jelszónak tartalmaznia kell kis betűt, nagy betűt és számot!')}}</span>
				</div>
			</div>

			<div class="form-group form-group--password form-group--with-icon pb-4">
                <label for="passwordConfirm" class="d-none">{{$t('Jelszó ismét')}}</label>
				<input
					ref="passwordConfirm"
                    id="passwordConfirm"
					v-model.trim="$v.passwordConfirm.$model"
					v-input-class
					:type="showPasswordConfirm? 'text' : 'password'"
					class="input"
					:placeholder="$t('Jelszó ismét')"
				/>
				<span class="input__icon">
					<img src="@/assets/icons/lock.svg" :alt="$t('Jelszó ismét')" />
				</span>
                <button
					type="button"
					@click.prevent.stop="showPasswordConfirm = !showPasswordConfirm"
					class="input__show-password"
				>
                    <inline-svg :src="require('@/assets/icons/eye-crossed.svg')"></inline-svg>
				</button>
				<div class="input__error" v-show="$v.passwordConfirm.$error">
					<span>
						<img src="@/assets/icons/warning.svg" alt="Hiba" />
					</span>
					<span v-if="!$v.passwordConfirm.required">{{$t('A mező kitöltése kötelező!')}}</span>
					<span v-else-if="!$v.passwordConfirm.sameAsPassword">{{$t('A beírt jelszavak nem egyeznek!')}}</span>
				</div>
			</div>

            <div class="form-group form-group--checkbox text-left">
					<div class="checkbox">
						<input
							v-model="$v.tosAccepted.$model"
							type="checkbox"
							id="tosAccepted"
							class="checkbox__input"
						/>
						<label for="tosAccepted" class="checkbox__label"></label>
					</div>

					<label for="tosAccepted" v-html="$t('Elfogadom az {linkStart}Általános Szerződési feltételeket{linkEnd}', {'linkStart': '<a href=\'/docs/terms_of_service.pdf\' target=\'_blank\'>', 'linkEnd': '</a>'})">
					</label>
				</div>

            <div class="form-group form-group--checkbox text-left">
					<div class="checkbox">
						<input
							v-model="$v.privacyAccepted.$model"
							type="checkbox"
							id="privacyAccepted"
							class="checkbox__input"
						/>
						<label for="privacyAccepted" class="checkbox__label"></label>
					</div>

					<label for="privacyAccepted" v-html="$t('Elfogadom az {linkStart}Adatvédelmi Szabályzatot{linkEnd}', {'linkStart': '<a href=\'/docs/privacy_policy.pdf\' target=\'_blank\'>', 'linkEnd': '</a>'})">
					</label>
				</div>

			<div class="pb-4">
				<button
					:disabled="$v.$invalid?'disabled':false"
					type="submit"
					class="button w-100"
				>{{$t('Regisztráció')}}</button>
			</div>
		</form>

		<div class="text-smaller color-grey3">
			{{$t('Már van fiókja?')}}
			<router-link class="link-dark" :to="{name: 'login'}">{{ $t('Bejelentkezés') }}</router-link>
		</div>
	</div>
</template>

<script>
import { registerAccountUsingPOST } from "@/api";
import { ManagedUserVM } from "@/models";
import { removeNullKeys } from "@/utils";

import Password from '@/components/PasswordStrengthMeter.vue'

import {
	required,
	maxLength,
	minLength,
	email,
	sameAs,
} from "vuelidate/lib/validators";

export default {
    name: "Registration",
    components: { Password },
	data() {
		return {
            submitted: false,
            showPassword: false,
            showPasswordConfirm: false,
            passwordConfirm: null,
            privacyAccepted: false,
            tosAccepted: false,
			managedUserVM: new ManagedUserVM(),
		};
	},
	validations: {
		managedUserVM: {
			email: {
				required,
				email,
			},
			phone: {
				required,
				minLength: minLength(10),
				maxLength: maxLength(20),
			},
			name: {
				required,
			},
			password: {
                required,
				minLength: minLength(8),
                maxLength: maxLength(100),
                goodPassword:(password) => {
                    return /[a-z]/.test(password) &&
                    /[A-Z]/.test(password) &&
                    /[0-9]/.test(password)
                }
			},
		},
		passwordConfirm: {
			required,
			sameAsPassword: sameAs(function () {
				return this.managedUserVM.password;
			}),
        },
        privacyAccepted: {
            sameAs: sameAs( () => true )
        },
        tosAccepted: {
            sameAs: sameAs( () => true )
        }
	},
	methods: {
		submit: function () {
			this.submitted = true;

			if (this.$v.$invalid)
				return this.$swal({
					title: this.$t("Regisztráció"),
					text: this.$t("Az összes mező kitöltése kötelező!"),
					imageUrl: window.swalError,
				});

			registerAccountUsingPOST({
				managedUserVm: removeNullKeys(this.managedUserVM),
			})
				.then((response) => {
						this.$swal({
							title: this.$t("Sikeres regisztráció"),
							text: this.$t("A regisztráció sikeres volt, most beléptetjük az oldalra."),
							imageUrl: window.swalSuccess,
							confirmButtonText: this.$t("Tovább"),
						}).then(() => {
							this.$store.commit(
								"loggedIn",
								response.data.id_token
							);
							this.$router.push(this.$route.query.redirect || {name: 'demand-request'})
						});
				})
				.catch((err) => {
                    console.warn(err);
					this.$swal({
						title: this.$t("Regisztráció"),
						text:
							this.$t("A regisztráció sikertelen volt. Hiba üzenet:") + " " + err.errorMessage,
						imageUrl: window.swalError,
						confirmButtonText: this.$t("Tovább"),
					});
				});
		},
	},
	created() {
		this.managedUserVM.langKey = this.$i18n.locale;
	},
};
</script>